export default __webpack_public_path__ + "static/media/35225371_10156435174191369_3919318894967259136_n.bcc2e7d6.jpg";